import createCorrelationId from '../utils/createCorrelationId';

declare global {
  interface Window {
    correlationId?: string;
  }
}

export function getCorrelationId(): string {
  if (typeof window === 'undefined') {
    return createCorrelationId();
  }

  if (!window.correlationId) {
    window.correlationId = createCorrelationId();
  }

  return window.correlationId;
}
